import React, { useEffect, useState } from 'react';

const ProcedureData = () => {
  const [query, setQuery] = useState(''); // For search input
  const [results, setResults] = useState([]); // Store the search results
  const [loading, setLoading] = useState(false); // Loading state
  const [error, setError] = useState(null); // Error handling

  // Function to handle API search
  const searchProcedure = async () => {
  //  const url = `https://fhir-api.akosmd.com/api/fhir/resource/Procedure?code=${query}`; // Surgical History
    const url = `https://fhir-api.akosmd.com/api/fhir/resource/Condition?name=${query}`; // Medical History

    const token = `Bearer ${process.env.REACT_APP_FHIR_API_TOKEN}`;

    setLoading(true); // Show loading state

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token,
        },
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status} ${response.statusText}`);
      }

      const data = await response.json(); // Parse the response JSON
      setResults(data.entry || []); // Store results (assuming 'entry' contains the list)
    } catch (err) {
      setError(err.message); // Handle any errors
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <div>
      <h1>Search Procedures</h1>

      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Enter procedure name"
      />
      <button onClick={searchProcedure}>Search</button>

      {loading && <p>Loading...</p>}
      {error && <p style={{ color: 'red' }}>Error: {error}</p>}

      <ul>
        {results.map((item, index) => (
          <li key={index}>
           {item.resource?.code?.text || 'N/A'} <br />
            {/* <strong>Status:</strong> {item.resource?.clinicalStatus?.coding[0]?.code || 'N/A'} <br />
            <strong>Recorded Date:</strong> {item.resource?.recordedDate || 'N/A'} */}
          </li>
        ))}
      </ul>
    </div>
  );
};
  
  export default ProcedureData;